import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';

@Component({
    selector: 'app-members-delete',
    templateUrl: './category-delete.component.html'
})
export class CategoryDeleteComponent {
    dialogTitle: string;
    text: any;

    constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
        this.dialogTitle = this.data.name;
        this.text = this.data.questions;
    }
}
